import {VariantConfigT} from '@/lib/types/colors.types';

export const facebookConfig: VariantConfigT = {
  basic: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  outline: {
    icon: 'facebook',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'facebook',
    iconHover: 'facebook',
    iconActive: 'facebook',
    hover: 'facebook',
    active: 'facebook',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
